import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {TransferHistory} from "../models/History/transfer.history";
import {TransferType} from "../models/History/transfer-type.enum";

@Injectable({
    providedIn: "root"
})
export class TransferService {

    private readonly base = environment.backendBaseUrl;
    private readonly endpoint = "/api/transfers";
    private readonly fullPath = `${this.base}${this.endpoint}`;
    private readonly searchURL = `${this.fullPath}/history`;

    constructor(private http: HttpClient) {
    }

    search(
        pageNumber: number,
        pageSize: number,
        transferType: TransferType
    ) {
        const params = new HttpParams()
            .set("pageNumber", String(pageNumber))
            .append("transferType", String(transferType))
            .append("pageSize", String(pageSize));

        return this.http.get<TransferHistory>(this.searchURL, {
            params
        });
    }
}
